import React from "react";
import styles from './ContactUs.module.css';

interface Props {
    value: string,
    label?: string,
    onInputChange: Function,
    required?: boolean,
    options: {label: string, value: string, icon: string}[] | string[],
    defaultOption: string,
    extraClass: any
}

const SelectInput = ({ label, onInputChange, value, required, options, defaultOption = 'Select Time', extraClass }: Props) => {
    let s = {
        container: (provider, state) => ({
            ...provider,
            marginTop: "0.5rem"
        })
    }
    return <label className={`${styles.TextInputLabel} ${extraClass ? extraClass : ''}`} htmlFor={label?.replaceAll(' ', '-')}>{label}
        <select  id={label?.replaceAll(' ', '-')} className={styles.SelectBox} onChange={e => onInputChange(e.target.value)} required={required} value={value}>

            {defaultOption !== '' && (
                <option>
                    {defaultOption}
                </option>
            )}


            {options.map((option, index) => {
                if (typeof option === 'string') {
                    return (
                        <option key={index} value={option}>
                            {option}
                        </option>
                    )
                } else {
                    return (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>

                    )
                }
            }
            )}
        </select>
    </label>
}

export default SelectInput;
